import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Finance contacts" hint="Clients + vendors from the finance engine." /> }
